import { createReducer, on } from '@ngrx/store';

import { setViewTypeSuccess } from '../actions/filter.actions';

export interface Filter {
  displayView: 'thumbnail' | 'list';
}

export const initialState: Filter = {
  displayView: 'list',
};
/* tslint:disable */
export const filterReducer = createReducer(
  initialState,
  on(setViewTypeSuccess, (state, { payload }) => ({ ...state, displayView: payload ?? 'list' })),
);
